// 组件对象，大写
import selectRemote from './selectRemote.vue'
export default selectRemote
